import React, {useEffect, useState } from "react";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Table,
  Input,
  Label,
  Modal,
  Button,
  InputGroup,

} from "reactstrap";


// Redux
import { connect, useDispatch} from "react-redux";
import { withRouter, Link} from "react-router-dom";


//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Pagination from "../../components/Common/Pagination";
import Loader from "../../components/Common/Loader";

import SweetAlert from "react-bootstrap-sweetalert";
//Action
import { rolCreate, rolList } from "../../store/actions";
import { rolFilter } from "../../store/actions";


const RolList = (props) => {
const dispatch= useDispatch();
const user = JSON.parse(localStorage.getItem("user"))
const groups  =String(user.groups);


const [search, setSearch] = useState("");

const onChange = (e) => {
  setSearch(e.target.value);
};

const onSubmit = (e) => {
  e.preventDefault();
  dispatch(rolFilter(`?search=${search}`));
};

const resetSearch = () => {
  dispatch(rolFilter(`?search=`));
  setSearch("");
};

useEffect(() => {
  dispatch(rolList());
},[dispatch]);

const [show, setShow] = useState(false);
const [rolNombre, setRolNombre] = useState("");
const [error, setError] = useState(false)


const handlerolCreate = ()=>{
    setShow(true)
};

const handleRolNombre = (e)=>{
    setRolNombre(e.target.value)
};

const onSubmitRol = ()=>{
  if(rolNombre !== ""){
    dispatch(rolCreate({
        nombre: rolNombre,
    }))
    setShow(false);
  }
  else{
    setError(true);
  }
}

const params = {
  count: props.rol.count,
  next: props.rol.next,
  previous: props.rol.previous,
  results: props.rol.results,
};


  return (
    <React.Fragment>
    <div className="page-content">
      <MetaTags>
        <title>tccontrol | Roles</title>
      </MetaTags>
      <Container fluid>
        {/* Render Breadcrumb */}
        <Breadcrumb title={"tccontrol"} breadcrumbItem={"Roles"} />
        {props.loading ? (
          <Loader />
        ) : (
          <div>
            {props.rolCreated.id  ? (
              <SweetAlert
                title="Hecho!"
                success
                // timeout={2000}
                showConfirm={true}
                onConfirm={() => {
                  dispatch (rolList());
                }}
              >
                Se ha agregado el Rol con éxito 
              </SweetAlert>
            ) : null}

            {error  ? (
              <SweetAlert
                title="Error"
                warning
                // timeout={2000}
                showConfirm={true}
                onConfirm={() => {
                  setError(false);
                }}
              >
                Este Campo no puede estar Vacio
              </SweetAlert>
            ) : null}

            <Card className= "col-lg-10 mx-auto  mt-3">
                <Modal
                  isOpen={show}
                  centered={true}
                  toggle = {()=> setShow(false)}
                  

                >
                  <div className="modal-header">
                      <h3 className="modal-title mt-2">
                          Rol
                      </h3>
                      <button
                          type="button"
                          onClick={() => {
                              setShow(false);
                          }}
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                      >
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div className="modal-body">
                  <Row className="col-lg-12 justify-content-center">
                  <Col lg={10} className="mb-3">
                      <Label
                        for="nombre"
                        className="form-label"
                      >
                     Nombre
                      </Label>
                      <Input
                          type="text"
                          className="form-control"
                          name="nombre"
                          placeholder="Escriba un Rol"
                          onChange={handleRolNombre}
                          
                        />
                    </Col>
                    </Row>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {                        
                        setShow(false)
                      }}
                      > Atras
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={()=> onSubmitRol()}   
                    >
                          Guardar
                    </button>
                  </div>
                </div>
                </Modal>


                {/* Cardbody de boton de agregar y filtro */}       
              <CardBody>
                <Row>
                  <Col md={7}>
                  {groups.includes("SuperAdmin") ||  groups.includes("Supervisor") || groups.includes("Operador") ? (
                    <Link
                      className="btn btn-primary waves-effect waves-light"
                      to="#"
                      onClick={handlerolCreate}
                    >
                      Agregar Nuevo Rol{" "}
                      <span className=""></span>
                    </Link>
                  ):null}
                  </Col>
                  <Col md={5}>
                    <Form
                      className="search-box"
                      onSubmit={onSubmit}
                    >
                      <InputGroup>
                        <Input
                          type="text"
                          className="form-control"
                          name="search"
                          placeholder="Buscar"
                          value={search}
                          onChange={onChange}
                          
                        />
                        <i className="bx bx-search-alt search-icon" />
                        <Button color="primary" onClick={resetSearch}>
                          <span className=" bx bx-x fa-lg align-middle"></span>
                        </Button>
                      </InputGroup>
                    </Form>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card className= "col-lg-10 mx-auto  mt-3">
            {params.count !== 0 ? (
                <CardBody>
                  <h4 className="card-title">Roles</h4>
                  <div className="table-responsive">
                    <Table
                      className="table table-lg table-borderless table-striped align-middle table-centered table-nowrap mb-3 "
                      style={{
                        textAlign: "center",
                      }}
                      hover
                    >
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Rol</th>
                          {groups.includes("SuperAdmin") ||  groups.includes("Supervisor") || groups.includes("Operador") ? (
                          <th>Acción</th> 
                          ):null}
                        </tr>
                      </thead>
                      <tbody>
                          {params.results &&
                            params.results.map((rol, idx) => (
                              <tr key={idx}>
                                <th scope="row">{idx + 1}</th>
                                <td>{rol.nombre}</td>                                
                                <td>
                                {groups.includes("SuperAdmin") ||  groups.includes("Supervisor") || groups.includes("Operador") ? (
                                <Link to = ''                               
                                  >
                                    <span className="bx bx-edit bx-sm align-middle"></span>
                                  </Link> 
                                  ):null} {" "}
                               {groups.includes("SuperAdmin") ||  groups.includes("Supervisor")  ? (
                                <>
                                  <Link  to=""                              
                                >
                                  <span className="bx bx-trash bx-sm align-middle"></span>
                                </Link>

                                <Link to={`/rol/permission_assign/${rol.id}`} id="permission">
                                  <span className="fa fa-lock fa-lg mx-1"></span>
                                </Link>
                               
                                </>
                              ): null}
                                </td> 
                              </tr>
                            ))}
                        </tbody>
                      
                    </Table>
                  </div>
                   <Pagination
                      count={params.count}
                      next={params.next}
                      previous={params.previous}
                      limit={10}
                      baseUrl="rol/"
                      filterFunction={rolFilter}
                    />
                </CardBody>
          ) : ( 
                <CardBody>
                  <h4 className="card-title">No se encontraron resultados</h4>
                </CardBody>
          )}
            </Card>
        
          </div>
        )}
      </Container>

    </div>
  </React.Fragment>
);
};
const mapStateToProps = (state) => {
  const { error, loading, rol, rolCreated} = state.Rol;
  return { error, loading, rol, rolCreated };
};
RolList.propTypes = {
    error: PropTypes.any,
    loading: PropTypes.bool,
    rolCreated: PropTypes.object,
    };
export default withRouter(connect(mapStateToProps , { rolList, rolCreate }) (RolList));